import { render, staticRenderFns } from "./YoutubeEmbed.vue?vue&type=template&id=2de5b9d0"
import script from "./YoutubeEmbed.vue?vue&type=script&lang=js"
export * from "./YoutubeEmbed.vue?vue&type=script&lang=js"
import style0 from "./YoutubeEmbed.vue?vue&type=style&index=0&id=2de5b9d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports